import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Cta from "../../../components/cta/Cta";
import InfoGraph from "../../../components/infoGraph/infoGraph";
import AppProgressInfo from "../../../components/appProgressInfo/appProgressInfo";
import { SurveyContext } from "../../../store/survey-context";
import { setAppBackground } from "../../../utils";
import "./welcome-screen.scss";
export default function WelcomeScreen() {
  const { userProfile } = useContext(SurveyContext);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setAppBackground(`Hero-1b.png`);
  }, []);

  const { t } = useTranslation("common");
  let welcomeText = "",
    titleText = "",
    bodyText = [],
    graphic;

  // user completed all the questions
  if (userProfile.percentageCompletionValues?.overall === 100) {
    welcomeText = t("welcome_screen.welcome_back");
    titleText = t("welcome_screen.title3");
    bodyText = [t("welcome_screen.body3")];
    graphic = <AppProgressInfo dataApi={true} />;
    // user started the survey, but not completed yet
  } else if (
    userProfile.percentageCompletionValues?.overall > 0 ||
    userProfile.markedForLater?.length > 0
  ) {
    welcomeText = t("welcome_screen.welcome_back");
    titleText = t("welcome_screen.title2");
    bodyText = [t("welcome_screen.body2")];
    // user hasn't answered any question yet
    graphic = <AppProgressInfo dataApi={true} />;
  } else {
    welcomeText = t("welcome_screen.welcome");
    titleText = t("welcome_screen.title1");
    bodyText = [
      t("welcome_screen.body1_1"),
      t("welcome_screen.body1_2"),
      t("welcome_screen.body1_3"),
    ];
    graphic = <InfoGraph />;
  }
  return (
    <div className="welcome mv-xl">
      <div className="claim fade-in">
        <h1 className="headline--primary mb-50 text-uppercase break-word">
          {welcomeText} {userProfile.firstName} {userProfile.lastName}
        </h1>
        <em className="em">{titleText}</em>
        <div>
          {bodyText.map((text, key) => (
            <p>{text}</p>
          ))}
        </div>
        <div className="mv-50">{graphic}</div>
      </div>
      <div className="flex-center action-bar">
        <Cta path="/questionnaire" ctaClass="cta--primary cta--centered next">
          {t("button.begin")}
        </Cta>
      </div>
    </div>
  );
}
